
import AxiosAPI from "./AxiosAPI";

export const handleAddCustomField = async (data) => {
  try {
    const response = await AxiosAPI.post("/setup/customfield", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response from add custom field:", response);
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
};

export const handleEditCustomField= async (data) => {  
  try {
    const response = await AxiosAPI.put(
      `/setup/customfield/${data.key}`,
      data,{
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const fetchCustomField = async () => {
  try {
    const response = await AxiosAPI.get("/setup/customfield");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};


export const deleteCategory = async (key) => { 
  try {
    const response = await AxiosAPI.delete(
      `/setup/customfield/${key}`
    );
    return response.data;
  } catch (err) {
    console.log(err);
    
  }
};

